import { post, put, get, deleteReq } from './api';

export const serializeTagsAsGetParam = tags => {
  if (!tags || !tags.length) return '';
  return tags.map(tag => `tags[]=${tag}`).join('&');
};

export const fetchBookletList = ({ tags }) =>
  get(`/booklets?${serializeTagsAsGetParam(tags)}`);

export const fetchBookletArchive = ({ tags }) =>
  get(
    `/booklets?archived=true${
      tags && tags.length ? `&${serializeTagsAsGetParam(tags)}` : ''
    }`
  );

export const createNewBooklet = booklet =>
  post(`/booklets/`, JSON.stringify(booklet), {
    'Content-Type': 'application/json',
  });

export const editBooklet = booklet =>
  put(`/booklets/${booklet.booklet.id}`, JSON.stringify(booklet), {
    'Content-Type': 'application/json',
  });

export const fetchBooklet = ({ id }) => get(`/booklets/${id}`);

export const editHeroImage = ({ id, heroImageId, body, options }) =>
  put(`/booklets/${id}/hero_images/${heroImageId}`, body, {
    ...options,
  });

export const fetchTagsList = ({ query }) => get(`/tags?q=${query}`);

export const fetchAllTagsList = () => get(`/tags`);

export const fetchRelatedTagsList = ({ tags }) =>
  get(`/tags/related?${serializeTagsAsGetParam(tags)}`);

export const removeBookletApi = ({ bookletId, heroImageId }) =>
  deleteReq(`/booklets/${bookletId}/hero_images/${heroImageId}`);



// WEBPACK FOOTER //
// ./src/services/bookletApi.js